export default __webpack_public_path__ + "static/media/waterfall.80d6c3be.svg";